import MastercardLogoImage from './assets/logos/mastercard-logo.svg';
import NotionLogoImage from './assets/logos/notion-logo.svg';
import OkCupidLogoImage from './assets/logos/okcupid-logo.svg';
import RevolutLogoImage from './assets/logos/revolut-logo.svg';
import StarbucksLogoImage from './assets/logos/starbucks-logo.svg';
import SocialProofCarousel from './components/SocialProofCarousel';
import { SocialProofAccentContainer, SocialProofBanner, SocialProofLogosContainer } from './styles';

const SocialProofAccent = () => (
    <SocialProofAccentContainer direction="column" align="center" justify="center">
        <SocialProofCarousel />
        <SocialProofBanner direction="column" align="center" justify="center" gap={5}>
            Trusted by over 3000 leading companies
            <SocialProofLogosContainer
                data-testid="social-proof-logos-container"
                align="center"
                justify="center"
                wrap="wrap"
                gap={5}
            >
                <img src={NotionLogoImage} alt="Notion Logo" />
                <img src={RevolutLogoImage} alt="Revolut Logo" />
                <img src={OkCupidLogoImage} alt="OkCupid Logo" />
                <img src={StarbucksLogoImage} alt="Starbucks Logo" />
                <img src={MastercardLogoImage} alt="Mastercard Logo" />
            </SocialProofLogosContainer>
        </SocialProofBanner>
    </SocialProofAccentContainer>
);

export default SocialProofAccent;
